import { IComponentSearchResultsFillerCard } from '@/types/cms';
import { CommonImage } from '../CommonImage';
import Link from 'next/link';

interface ResultsFillerCardProps {
  item: IComponentSearchResultsFillerCard;
}

export const ResultsFillerCard = ({ item }: ResultsFillerCardProps) => {
  if (item.use_image_instead) {
    const imgElm = (
      <CommonImage
        src={item.image_url}
        alt={item.title}
        className="size-full bg-white border border-black-100 shadow-[0px_4px_10px_0px_#00000026] rounded-[0.625rem] overflow-hidden"
      />
    );

    if (item.image_action_link) {
      return <Link href={item.image_action_link}>{imgElm}</Link>;
    }

    return imgElm;
  }

  let iconElm = null;
  if (item.icon) {
    if (item.icon.startsWith('<svg'))
      iconElm = <span className="w-16" dangerouslySetInnerHTML={{ __html: item.icon }} />;
    else iconElm = <CommonImage src={item.icon} alt={item.title} className="w-16" />;
  }

  return (
    <div className="h-[37.5rem] w-full md:h-full rounded-[0.625rem] bg-white border border-black-100 shadow-[0px_4px_10px_0px_#00000026] flex flex-col items-center justify-center gap-5 font-helvetica">
      {iconElm}
      {(item.title || item.description) && (
        <div className="flex flex-col items-center gap-3.5 px-10">
          {item.title && <h3 className="text-xl font-bold text-center text-blue-500">{item.title}</h3>}
          {item.description && <p className="text-black-350 text-sm md:text-base text-center">{item.description}</p>}
        </div>
      )}
      {item.cta_text && (
        <Link
          href={item.cta_link || '#'}
          className="w-[16.75rem] rounded-sm text-sm md:text-base border border-blue-500 bg-white flex items-center justify-center py-3 md:py-2.5 text-blue-500 hover:bg-blue-500 hover:text-white"
        >
          {item.cta_text}
        </Link>
      )}
    </div>
  );
};
